<template>
  <div>
    <div>
      <div class="weui-panel__hd">退税单</div>
      <div v-show="isLogin" class="weui-flex">
        <div class="weui-panel filter" v-if="false">
          <div class="weui-panel__bd">
            <div class="weui-media-box weui-media-box_small-appmsg">
              <div class="weui-cells">
                <a class="weui-cell weui-cell_access" v-bind:class="active==0?'active':''" @click="select(0)" href="javascript:;">
                  <div class="weui-cell__bd weui-cell_primary">
                    <p>未传小票</p>
                  </div>
                </a>
                <a class="weui-cell weui-cell_access" v-bind:class="active==1?'active':''" @click="select(1)" href="javascript:;">
                  <div class="weui-cell__bd weui-cell_primary">
                    <p>审核失败</p>
                  </div>
                </a>
                <a class="weui-cell weui-cell_access" v-bind:class="active==2?'active':''" @click="select(2)" href="javascript:;">
                  <div class="weui-cell__bd weui-cell_primary">
                    <p>通过审核</p>
                  </div>
                </a>
                <a class="weui-cell weui-cell_access" v-bind:class="active==3?'active':''" @click="select(3)" href="javascript:;">
                  <div class="weui-cell__bd weui-cell_primary">
                    <p>送达</p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="weui-flex__item">
          <div class="weui-panel weui-panel_access">
            <div class="weui-panel__bd">
              <div class="weui-loadmore" v-if="isShowLoadmore">
                <i class="weui-loading"></i>
                <span class="weui-loadmore__tips">正在加载</span>
              </div>
              <a v-for="entry in currentFormGroup.forms" href="javascript:void(0);" class="weui-media-box weui-media-box_appmsg">
                <div class="weui-media-box__hd">
                  <img class="weui-media-box__thumb" src="../assets/taxform_grey_180.png" alt="">
                </div>
                <div class="weui-media-box__bd">
                  <h4 class="weui-media-box__title">{{entry.identifier}}</h4>
                  <p class="weui-media-box__desc">
                    <span>金额: {{entry.amount}} 欧</span>
                    <span>可退: {{entry.refund}} 欧</span>
                  </p>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-show="!isLogin">
        <div class="weui-footer">
          <p class="weui-footer__text">请登录查看退税单</p>
        </div>
      </div>
    </div>

    <tab-bar></tab-bar>
    <download-app></download-app>
  </div>
</template>
<style lang="stylus">
  .filter
    border-right: 1px solid #d9d9d9
  .active
    background-color #ececec
</style>
<script>
  import store from '../store/user.js'
  import api from '../service/api.js'
  import utils from '../utils/common.js'
  import TabBar from '../components/TabBar'
  import DownloadApp from '../components/DownloadApp'

  function userInfo () {
    return store.getters.getUserInfo
  }

  function currentFormGroup () {
    return store.getters.getCurrentFormGroup
  }

  export default{
    computed: {
      currentFormGroup,

      isLogin () {
        return this.$store.getters.getIsLogin
      },

      isShowLoadmore () {
        return utils.isEmptyObject(this.currentFormGroup)
      }
    },

    data () {
      return {
        active: 0,
        isShowDownloadDialog: false
      }
    },

    methods: {
      select (index) {
        this.active = index
      }
    },

    beforeRouteEnter (to, from, next) {
      if (store.getters.getIsLogin) {
        api.get('formGroups/' + userInfo().selectedFormGroupId
        ).then((response) => {
          store.dispatch('setCurrentFormGroup', response.data)
        }).catch((error) => {
          console.log(error)
        })
      } else {
        store.commit('setShowLogin', true)
      }

      next()
    },

    components: {
      TabBar,
      DownloadApp
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?0b6a6f08